module.exports = "/_next/static/images/6c1631f5feefa67209fe99afb34e4cad-device-frame@0.75x.png.webp";